import { VButton, VInput } from '@vrzl/ui';
import { Send } from 'lucide-react';
import { useState } from 'react';

type ChatComposerProps = {
  disabled: boolean;
  onSend: (text: string) => void;
};

export function ChatComposer({ disabled, onSend }: ChatComposerProps) {
  const [text, setText] = useState('');

  function submit() {
    const trimmed = text.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setText('');
  }

  return (
    <form
      className="flex items-center gap-2"
      onSubmit={(event) => {
        event.preventDefault();
        submit();
      }}
    >
      <VInput
        className="flex-1"
        placeholder="Stel een vraag over het evenement..."
        value={text}
        onChange={(event) => setText(event.target.value)}
        disabled={disabled}
      />
      <VButton type="submit" icon={Send} aria-label="Verstuur" disabled={disabled || !text.trim()} />
    </form>
  );
}
